import fn from './helper';
import CustomSelect from './CustomSelect';

class Ajax {
  static init(cSelect, pageScroller) {
    this.formAjax(cSelect, pageScroller);
  }

  static formAjax(cSelect, pageScroller) {
    // get all input to use
    let customSelectClass = new CustomSelect;
    let daySelect = document.querySelector('[name="jour"]')
    let monthSelect = document.querySelector('[name="mois"]')
    let hourSelect = document.querySelector('[name="heure"]')
    let customSelect = document.querySelector('.custom-select-panel')
    let form = document.querySelector('form');
    let listenerDate = document.querySelectorAll('.formInput')
    let span = document.querySelector('[data-name="heure"]')

    // init pageScroller for change value
    customSelectClass.init(pageScroller)

    // lsitener on keyDown or if user click out focus field
    listenerDate.forEach((item) => {
      item.addEventListener('keydown', () => {
        if (daySelect.value != '' && monthSelect.value != '') {
          ajaxCall()
        }
      })
      item.addEventListener('focusout', () => {
        ajaxCall()
      })
    })

    function ajaxCall() {
      // prepare data from user input
      // date = date from input
      let date = new Date(monthSelect.value.trim() + '/' + daySelect.value.trim() + '/' + new Date().getFullYear())
      // current date = today
      let currentDate = new Date()
      // set +1 year if date from input < today
      if (date < currentDate) {
        date.setFullYear(date.getFullYear() + 1)
      }
      // format date
      let dateFormatted = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
      let day = date.getDay()
      let dayFormatted = ''
      switch (day) {
        case 1:
          dayFormatted = 'lundi'
          break;
        case 2:
          dayFormatted = 'mardi'
          break;
        case 3:
          dayFormatted = 'mercredi'
          break;
        case 4:
          dayFormatted = 'jeudi'
          break;
        case 5:
          dayFormatted = 'vendredi'
          break;
        case 6:
          dayFormatted = 'samedi'
          break;
        case 0:
          dayFormatted = 'dimanche'
          break;
      }
      fetch(adminAjax.ajaxurl, {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }),
        body: 'action=form_rdv'
      })
        .then(function (response) {
          if (response.ok) {
            return response.json();
          } else {
            return Promise.reject(response);
          }
        })
        .then(function (data) {
          // get all option for remove old data
          document.querySelectorAll('select[name="heure"] option').forEach((item) => {
            item.remove()
          })
          // use function getDates from helper to get
          // !!! naming , getDates (s) <= not getDate
          // all date after today for conge
          // need to push all date in aray dateConge
          // for compare dataConge with date from user input
          let dateConge = []
          let arrayConge = fn.getDates((new Date(data.data.congeStart)), (new Date(data.data.congeEnd)))
          arrayConge.forEach(element => {
            let date = new Date(element)
            let dateFormattedConge = date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear()
            dateConge.push(dateFormattedConge)
          })

          // first check if date from user is include on conge array,
          // return in option conge if include
          if (dateConge.includes(dateFormatted)) {
            let finalHour = []
            let isConge = "Nous sommes en congé ce jour"
            finalHour.push(isConge)
            fn.insertHour(hourSelect, finalHour, customSelect)
          } else {
            // finalHour = array for all hour dispo
            let finalHour = []
            // matin = array for all AM hour
            let matin = []
            // apresmidi = array for all PM hour
            let apresMidi = []

            // switch by day
            // check if hour is not empty for
            // each moment of day
            // each day remove class sunday
            if (dayFormatted == "lundi") {
              span?.classList.remove('sunday');
              let horaireDispoAm = data.data[0].horaire_am
              let horaireDispoPm = data.data[0].horaire_pm

              // verify if back has hour AP / PM
              // else if add to each array all hour
              if (horaireDispoAm != false) {
                let horaireAmStart = horaireDispoAm[0].hour_am_start
                let horaireAmEnd = horaireDispoAm[0].hour_am_end
                matin = fn.differenceHour(horaireAmStart, horaireAmEnd)
              }

              if (horaireDispoPm != false) {
                let horairePmStart = horaireDispoPm[0].hour_pm_start
                let horairePmEnd = horaireDispoPm[0].hour_pm_end
                apresMidi = fn.differenceHour(horairePmStart, horairePmEnd)
              }

              // get all hour dispo ( AM + PM )
              finalHour = matin.concat(apresMidi)
              // use function insertHour for insert in custom Select
              fn.insertHour(hourSelect, finalHour, customSelect)

            } else if (dayFormatted == "mardi") {
              span?.classList.remove('sunday');
              let horaireDispoAm = data.data[1].horaire_am
              let horaireDispoPm = data.data[1].horaire_pm

              if (horaireDispoAm != false) {
                let horaireAmStart = horaireDispoAm[0].hour_am_start
                let horaireAmEnd = horaireDispoAm[0].hour_am_end
                matin = fn.differenceHour(horaireAmStart, horaireAmEnd)
              }

              if (horaireDispoPm != false) {
                let horairePmStart = horaireDispoPm[0].hour_pm_start
                let horairePmEnd = horaireDispoPm[0].hour_pm_end
                apresMidi = fn.differenceHour(horairePmStart, horairePmEnd)
              }

              finalHour = matin.concat(apresMidi)
              fn.insertHour(hourSelect, finalHour, customSelect)
            } else if (dayFormatted == "mercredi") {
              span?.classList.remove('sunday');
              let horaireDispoAm = data.data[2].horaire_am
              let horaireDispoPm = data.data[2].horaire_pm

              if (horaireDispoAm != false) {
                let horaireAmStart = horaireDispoAm[0].hour_am_start
                let horaireAmEnd = horaireDispoAm[0].hour_am_end
                matin = fn.differenceHour(horaireAmStart, horaireAmEnd)
              }

              if (horaireDispoPm != false) {
                let horairePmStart = horaireDispoPm[0].hour_pm_start
                let horairePmEnd = horaireDispoPm[0].hour_pm_end
                apresMidi = fn.differenceHour(horairePmStart, horairePmEnd)
              }

              finalHour = matin.concat(apresMidi)
              fn.insertHour(hourSelect, finalHour, customSelect)
            } else if (dayFormatted == "jeudi") {
              span?.classList.remove('sunday');
              let horaireDispoAm = data.data[3].horaire_am
              let horaireDispoPm = data.data[3].horaire_pm

              if (horaireDispoAm != false) {
                let horaireAmStart = horaireDispoAm[0].hour_am_start
                let horaireAmEnd = horaireDispoAm[0].hour_am_end
                matin = fn.differenceHour(horaireAmStart, horaireAmEnd)
              }

              if (horaireDispoPm != false) {
                let horairePmStart = horaireDispoPm[0].hour_pm_start
                let horairePmEnd = horaireDispoPm[0].hour_pm_end
                apresMidi = fn.differenceHour(horairePmStart, horairePmEnd)
              }

              finalHour = matin.concat(apresMidi)
              fn.insertHour(hourSelect, finalHour, customSelect)
            } else if (dayFormatted == "vendredi") {
              span?.classList.remove('sunday');
              let horaireDispoAm = data.data[4].horaire_am
              let horaireDispoPm = data.data[4].horaire_pm

              if (horaireDispoAm != false) {
                let horaireAmStart = horaireDispoAm[0].hour_am_start
                let horaireAmEnd = horaireDispoAm[0].hour_am_end
                matin = fn.differenceHour(horaireAmStart, horaireAmEnd)
              }

              if (horaireDispoPm != false) {
                let horairePmStart = horaireDispoPm[0].hour_pm_start
                let horairePmEnd = horaireDispoPm[0].hour_pm_end
                apresMidi = fn.differenceHour(horairePmStart, horairePmEnd)
              }

              finalHour = matin.concat(apresMidi)
              fn.insertHour(hourSelect, finalHour, customSelect)
            } else if (dayFormatted == "samedi") {
              span?.classList.remove('sunday');
              let horaireDispoAm = data.data[5].horaire_am
              let horaireDispoPm = data.data[5].horaire_pm

              if (horaireDispoAm != false) {
                let horaireAmStart = horaireDispoAm[0].hour_am_start
                let horaireAmEnd = horaireDispoAm[0].hour_am_end
                matin = fn.differenceHour(horaireAmStart, horaireAmEnd)
              }

              if (horaireDispoPm != false) {
                let horairePmStart = horaireDispoPm[0].hour_pm_start
                let horairePmEnd = horaireDispoPm[0].hour_pm_end
                apresMidi = fn.differenceHour(horairePmStart, horairePmEnd)
              }

              finalHour = matin.concat(apresMidi)
              fn.insertHour(hourSelect, finalHour, customSelect)

            } else if (dayFormatted == "dimanche") {
              let dimanche = "fermé"
              finalHour.push(dimanche)
              fn.insertHour(hourSelect, finalHour, customSelect)
              span?.classList.add('sunday');
            }
            if (customSelectClass.isInitialising == true) {
              // need to destroy customSelect
              customSelectClass.destroy()
            }

            customSelectClass.init(pageScroller)
          }
        })
        .catch(function (err) {
          console.warn('Something went wrong.', err);
        });
    };
  }
}

export default Ajax;
